/**
 * @generated SignedSource<<76f34089643059059bea91211bde7723>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunReportInput = {
  reportId: string;
};
export type useReportRunMutation$variables = {
  input: RunReportInput;
};
export type useReportRunMutation$data = {
  readonly runReport: {
    readonly success: boolean | null;
  } | null;
};
export type useReportRunMutation = {
  variables: useReportRunMutation$variables;
  response: useReportRunMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RunReportPayload",
    "kind": "LinkedField",
    "name": "runReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89cdf49d3ba2c40d0144ce12ce283554",
    "id": null,
    "metadata": {},
    "name": "useReportRunMutation",
    "operationKind": "mutation",
    "text": "mutation useReportRunMutation(\n  $input: RunReportInput!\n) {\n  runReport(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee2e02c28ecf47272f167b234ce3366c";

export default node;
